module.exports = __webpack_public_path__ + "static/media/logo_corte.65fd2f30.png";